<app-header [active]="1" [circuito]="circuito"></app-header>


<div class="programacion">
  <!-- Breadcrumb trail: Mi Circuito > Grupo|Todos > Equipo|todos (design D5) -->
  <ol class="breadcrumb breadcrumb-programacion">
    <li class="breadcrumb-item"><a (click)="selectEtiqueta()">Mi Circuito</a></li>
    <li class="breadcrumb-item"><a
      (click)="id_grupo ? selectGrupo(grupoSelected) : selectGrupo(todosGrupo)">{{(id_grupo && grupoSelected) ? grupoSelected.nombre : 'Todos'}}</a>
    </li>
    <li class="breadcrumb-item"><a
      (click)="id_grupo ? selectEquipo(todosEquipo) : selectEtiqueta()">{{(id_equipo && equipoSelected && equipoSelected.id !== 0) ? equipoSelected.nombre : 'todos'}}</a>
    </li>
  </ol>
  <style>
    .breadcrumb-programacion {
      background-color: transparent;
      padding: 4px 10px 0;
      margin-bottom: 0;
    }
    .breadcrumb-programacion .breadcrumb-item a {
      cursor: pointer;
      color: #007bff;
      font-size: 12px;
      text-decoration: none;
    }
    .breadcrumb-programacion .breadcrumb-item a:hover {
      text-decoration: underline;
    }
    .breadcrumb-programacion .breadcrumb-item + .breadcrumb-item::before {
      content: ">";
    }
  </style>
  <div class="filter-container">
    <div ngbDropdown class="d-inline-block" style="padding-left: 10px;">
      <strong>
        <div style="font-size: 16px;display: inline-block">ETIQUETA:</div>
      </strong>
      <button class="btn selecione-grupo" ngbDropdownToggle
              style="border: solid 1px #c6c6c5; min-width: 100px;">
        {{etiquetaSelected ? etiquetaSelected.nombre : 'Mi Circuito'}}
      </button>
      <div ngbDropdownMenu>
        <button class="dropdown-item" *ngFor="let etiqueta of etiquetas" (click)="selectEtiqueta(etiqueta)">{{etiqueta.nombre}}
        </button>
      </div>
    </div>
    <div ngbDropdown class="d-inline-block" style="padding-left: 10px;">
      <strong>
        <div style="font-size: 16px;display: inline-block">GRUPO:</div>
      </strong>
      <button class="btn selecione-grupo" ngbDropdownToggle
              style="border: solid 1px #c6c6c5; min-width: 100px;">
        {{(id_grupo && grupoSelected) ? grupoSelected.nombre : 'Todos'}}
      </button>
      <div ngbDropdownMenu>
        <button class="dropdown-item" (click)="selectGrupo(todosGrupo)">Todos</button>
        <button class="dropdown-item" *ngFor="let grupo of grupos" (click)="selectGrupo(grupo)">{{grupo.nombre}}
        </button>
      </div>
    </div>
    <div ngbDropdown class="d-inline-block" style="padding-left: 10px">
      <strong>
        <div style="font-size: 16px;display: inline-block">EQUIPO:</div>
      </strong>
      <button class="btn selecione-grupo" id="dropdownBasic2" ngbDropdownToggle
              style="border: solid 1px #c6c6c5; min-width: 100px;">
        {{equipoSelected ? equipoSelected.nombre : 'Todos'}}
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
        <button class="dropdown-item" *ngFor="let equipo of equipos" (click)="selectEquipo(equipo)">{{equipo.nombre}}
        </button>
      </div>
    </div>
    <div class="opciones-right">
      <button class="button-dual button-dual-orange" style="height: 50px; border-radius: 5px;" (click)="agregarFrame()">
        AGREGAR FRAME
      </button>
      <button class="button-dual button-dual-green" style="height: 50px; border-radius: 5px;" (click)="saveProgramacion()"
              [ngClass]="{'button-dual-green':this.cambios,'button-dual-off':!this.cambios}">
        GUARDAR
      </button>
      <div class="delete-zone-container ">
        <div #placeholderNone></div>
        <div class="delete-zone"
             [dndList]="{ horizontal: 'true'}"
             [dndPlaceholder]="placeholderNone"
             [dndModel]="deletes">
          <app-item *ngFor="let item of deletes"
                    [dndType]="item.tipo"
                    [dndDraggable]
                    [dndObject]="item" class="item-pista"
                    [item]="item"
          ></app-item>
          <div class="delete-zone-text">
            <div style="display: table-cell; width:50px;  vertical-align: middle; text-align: center;">
              <img src="../../../assets/img/trash/delete-photo.png" style="display: inline-block">
            </div>
            <div style="display: table-cell">Arraste aqui <br>para borrar</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- PLACEHOLDER -->

  <div class="dndPlaceholder-container" #placeholder>
    <div class="dndPlaceholder">
    </div>
  </div>
  <br>
  <div>
    <h4 style="color:#111; margin-left: 10px">
      {{titulo}}
    </h4>
  </div>
  <div class="pantalla-completa-panel">
    <div class="header-panels">
      <div class="text-header-riel"> PANTALLA COMPLETA
      </div>
    </div>
    <div class="container-programacion">
      <div class="titulos">
        <div class="titulo">
          <div class="titulo-text">
            PROGRAMACIÓN
          </div>
        </div>
        <div class="titulo"
             style="border-top: solid 1px #c6c6c5; height: 78px !important;">
          <div class="titulo-text" style="background-color: #eee">
            FRAMES<br/>
            INACTIVOS
          </div>
        </div>
      </div>

      <!-- LISTAS DE ELEMENTOS DESPLAZABLES PARA LA PROGRAMACION DE PUBLICIDADES Y CONTENIDOS-->

      <div class="items-containers">
        <div class="pista-items"
             [dndList]="{ horizontal: 'true', allowedTypes: ['publicidad','contenido','programado','news-frame']}"
             [dndPlaceholder]="placeholder"
             [dndModel]="programacion_pantalla"
        >
          <app-item *ngFor="let item of programacion_pantalla"
                    [dndType]="item.tipo"
                    (dndMoved)="removeItem(item, programacion_pantalla,true)"
                    [dndDraggable]="{draggable:true, effectAllowed:'move'}"
                    (dndInserted)="removeFrame($event)"
                    [dndObject]="item" class="item-pista" [opacity]="1"
                    [item]="item" (click)="showViewFrame(item,true)">
          </app-item>
        </div>

        <!-- LISTAS DE ELEMENTOS DESPLAZABLES PARA CONTENIDOS-->

        <div class="pista-items" [dndList]="{ horizontal: 'true',
                allowedTypes: ['contenido','publicidad','programado','news-frame']}"
             style="background-color: #eee; border-top: solid 1px #c6c6c5;"
             [dndModel]="otros_frames"
             [dndPlaceholder]="placeholder">
          <app-item *ngFor="let item of otros_frames"
                    [dndType]="item.tipo"
                    [dndDraggable]="{draggable:true, effectAllowed:'move'}"
                    (dndMoved)="removeItem(item, otros_frames)"
                    (dndInserted)="insertItem($event)" [opacity]="0.5"
                    [dndObject]="item" class="item-pista"
                    [item]="item" (click)="showViewFrame(item,false)"
          >
          </app-item>
        </div>

      </div>
    </div>
  </div>
  <div style="text-align: right; color:#444; margin-top:5px; margin-bottom: 30px;">
    Tiempo total de programación: {{time_programacion}} (Publicidad:
    {{time_publicidad}}, Contenido: {{time_contenido}})
  </div>

  <!-- contratos-congelados T7: ZOCALO rail gated on features.zocalos
       (hidden only when explicitly false; missing flag stays visible).
       PANTALLA COMPLETA rail above is intentionally ungated. -->
  <div class="zocalos-panel" *ngIf="zocalosAllowed$ | async">
    <div class="header-panels">
      <div class="text-header-panel">ZOCALO</div>
    </div>
    <div class="container-programacion">
      <div class="titulos">
        <div class="titulo">
          <div class="titulo-text">
            PROGRAMACIÓN
          </div>
        </div>
        <div class="titulo" style="border-top: solid 1px #c6c6c5;">
          <div class="titulo-text" style="background-color: #eee">
            ZOCALOS<br/>
            INACTIVOS
          </div>
        </div>
        <!-- <div class="titulo">
          <div class="titulo-text">
            VARIOS<BR>
            (NOTICIAS)
          </div>
        </div> -->
      </div>

      <!-- LISTAS DE ELEMENTOS DESPLAZABLES PARA LA PROGRAMACION DE ZOCALOS Y NOTICIAS-->


      <div class="items-containers">
        <div class="pista-items"
             [dndList]="{ horizontal: 'true', allowedTypes: ['zocalo','noticia']}"
             [dndPlaceholder]="placeholder"
             [dndModel]="programacion_zocalos"
        >
          <app-item *ngFor="let item of programacion_zocalos"
                    [dndType]="item.tipo"
                    (dndMoved)="removeItem(item, programacion_zocalos,true)"
                    [dndDraggable]="{draggable:true, effectAllowed:'move'}"
                    (dndInserted)="removeFrame($event)"
                    [dndObject]="item" class="item-pista" [opacity]="1"
                    [item]="item" (click)="showViewFrame(item,true)">
          </app-item>
        </div>

        <!-- LISTAS DE ELEMENTOS DESPLAZABLES PARA CONTENIDOS-->

        <div class="pista-items" [dndList]="{ horizontal: 'true',
                allowedTypes: ['zocalo','noticia']}"
             style="background-color: #eee; border-top: solid 1px #c6c6c5;"
             [dndModel]="otros_zocalos"
             [dndPlaceholder]="placeholder">
          <app-item *ngFor="let item of otros_zocalos"
                    [dndType]="item.tipo"
                    [dndDraggable]="{draggable:true, effectAllowed:'move'}"
                    (dndMoved)="removeItem(item, otros_zocalos)"
                    (dndInserted)="insertItem($event)" [opacity]="0.5"
                    [dndObject]="item" class="item-pista"
                    [item]="item"
                    (click)="showViewFrame(item,false)"
          >
          </app-item>
        </div>
      </div>
    </div>
  </div>
</div>

<app-frame-view *ngIf="show_frame_view" (onclose)="closeframe()" [frame]="frameView"
                (save)="saveFrame($event)">
</app-frame-view>
<app-confirm-modal *ngIf="show_confirm_modal"
                   titulo="Cambios sin guardar"
                   [mensaje]="confirmMensaje"
                   botonConfirmar="Guardar todo"
                   botonCancelar="Cancelar"
                   (onConfirm)="onConfirmGuardarTodo()"
                   (onClose)="onConfirmCancelar()">
</app-confirm-modal>
<app-upload-form *ngIf="show_modal_frame" (onclose)="closeAgregar()" [newFrame]="newFrame"
                 [circuito]="circuito.id" (showFile)="showUploadFile($event)"
></app-upload-form>
<app-upload-view *ngIf="show_modal_file" [frame]="newFrame" (onclose)="closeAgregar()"
                 (crearFrame)="crearFrame($event)">
</app-upload-view>




// WEBPACK FOOTER //
// ./src/app/admin/programacion/programacion.component.html